import { render } from "./TopTrending.vue?vue&type=template&id=13648e10"
import script from "./TopTrending.vue?vue&type=script&lang=js"
export * from "./TopTrending.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__